import React from 'react'
import '../Styles/Home.css'
import HomeBanner from '../Components/Home/HomeBanner'
import HomeCounter from '../Components/Home/HomeCounter'
import HomeCategory from '../Components/Home/HomeCategory'
import HomeRestaurant from '../Components/Home/HomeRestaurant'

function Home() {
  return (
    <div>
      <HomeBanner />
      <HomeCounter />
      <HomeCategory />
      <HomeRestaurant />
    </div>
  )
}

export default Home